/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AlertOptions } from './AlertOptions';
import {
    AlertOptionsFromJSON,
    AlertOptionsFromJSONTyped,
    AlertOptionsToJSON,
    AlertOptionsToJSONTyped,
} from './AlertOptions';

/**
 * 
 * @export
 * @interface UpdateEmergencyConfigRequest
 */
export interface UpdateEmergencyConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmergencyConfigRequest
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmergencyConfigRequest
     */
    spec_name: string;
    /**
     * 
     * @type {AlertOptions}
     * @memberof UpdateEmergencyConfigRequest
     */
    impact_detection: AlertOptions;
    /**
     * 
     * @type {AlertOptions}
     * @memberof UpdateEmergencyConfigRequest
     */
    fall_detection: AlertOptions;
    /**
     * 
     * @type {AlertOptions}
     * @memberof UpdateEmergencyConfigRequest
     */
    arc_flash_detection: AlertOptions;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEmergencyConfigRequest
     */
    should_force_apply_this_update: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmergencyConfigRequest
     */
    config_id: string;
}



/**
 * Check if a given object implements the UpdateEmergencyConfigRequest interface.
 */
export function instanceOfUpdateEmergencyConfigRequest(value: object): value is UpdateEmergencyConfigRequest {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('spec_name' in value) || value['spec_name'] === undefined) return false;
    if (!('impact_detection' in value) || value['impact_detection'] === undefined) return false;
    if (!('fall_detection' in value) || value['fall_detection'] === undefined) return false;
    if (!('arc_flash_detection' in value) || value['arc_flash_detection'] === undefined) return false;
    if (!('should_force_apply_this_update' in value) || value['should_force_apply_this_update'] === undefined) return false;
    if (!('config_id' in value) || value['config_id'] === undefined) return false;
    return true;
}

export function UpdateEmergencyConfigRequestFromJSON(json: any): UpdateEmergencyConfigRequest {
    return UpdateEmergencyConfigRequestFromJSONTyped(json, false);
}

export function UpdateEmergencyConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmergencyConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'spec_name': json['spec_name'],
        'impact_detection': AlertOptionsFromJSON(json['impact_detection']),
        'fall_detection': AlertOptionsFromJSON(json['fall_detection']),
        'arc_flash_detection': AlertOptionsFromJSON(json['arc_flash_detection']),
        'should_force_apply_this_update': json['should_force_apply_this_update'],
        'config_id': json['config_id'],
    };
}

export function UpdateEmergencyConfigRequestToJSON(json: any): UpdateEmergencyConfigRequest {
    return UpdateEmergencyConfigRequestToJSONTyped(json, false);
}

export function UpdateEmergencyConfigRequestToJSONTyped(value?: UpdateEmergencyConfigRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'spec_name': value['spec_name'],
        'impact_detection': AlertOptionsToJSON(value['impact_detection']),
        'fall_detection': AlertOptionsToJSON(value['fall_detection']),
        'arc_flash_detection': AlertOptionsToJSON(value['arc_flash_detection']),
        'should_force_apply_this_update': value['should_force_apply_this_update'],
        'config_id': value['config_id'],
    };
}

